import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import type { SxProps, Theme } from '@mui/material/styles';

import { formatCompactRelativeTimestamp } from '@/lib/utils';

type CompactRelativeTimestampProps = {
  timestamp: string;
  className?: string;
  sx?: SxProps<Theme>;
};

export const CompactRelativeTimestamp: React.FC<CompactRelativeTimestampProps> = ({
  timestamp,
  className,
  sx,
}) => {
  const date = new Date(timestamp);

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  const relativeTimestamp = formatCompactRelativeTimestamp(timestamp);

  if (relativeTimestamp === null) {
    return null;
  }

  return (
    <Tooltip title={date.toLocaleString()} arrow>
      <Box component="span">
        <Box component="time" className={className} dateTime={timestamp} sx={sx}>
          {relativeTimestamp}
        </Box>
      </Box>
    </Tooltip>
  );
};
